import PropTypes from 'prop-types';
import React from 'react';

import { ConfigsService, ContentZonesService, LocaleService, UrlService } from '@sm360/widget-commons-core-services';
import { LEAD_TYPES, Lead, LeadService, ShiftDigitalService, CookieService } from '@sm360/widget-commons-general';
import { Vehicle, Quote, ShowroomService } from '@sm360/widget-commons-vehicle';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'vdp-used/actions/vdpUsedActions.js';

import FormAskQuestion from 'vdp-used/components/VdpForm/components/FormAskQuestion.jsx';

import 'vdp-used/components/VdpForm/VdpForm.scss';

class VdpForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showForm: true,
            message: null,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSDLeadEvent = this.handleSDLeadEvent.bind(this);
    }

    handleSubmit(formInputs) {
        const saveNewQuoteV25 = new Quote.SaveNewQuoteModelV25().setModelValuesFromQuoteModelV25(
            this.props.quoteV25.set('accountId', '').set('id', '')
        );

        // Create public quote
        new Promise((resolve) => {
            ShowroomService.saveQuoteV25(saveNewQuoteV25, true, this.props.config)
                .then((quoteId) => {
                    resolve(quoteId);
                })
                .catch(() => {
                    resolve('');
                });
        })
            .then((quoteId) => {
                const trackedUrl = {
                    trackedUrl: `${UrlService.getUrlOriginAndPath()}${quoteId ? `?quoteId=${quoteId}` : ''}`,
                    sourceUrl: '',
                };
                CookieService.save('primary-tracked-page', trackedUrl);

                const lead = new Lead({
                    depositCreation: {
                        websiteId: this.props.config?.websiteId || ConfigsService.getWebsiteId(),
                        vehicleInventoryId: this.props.vehicleId,
                        contactInfo: formInputs,
                    },
                    leadCarInfo: {
                        vehicleInventoryId: this.props.vehicleId,
                    },
                    leadType: LEAD_TYPES.INFO_REQUEST_USED,
                    leadInfo: `\n*** ${formInputs.question}\n`,
                });

                return LeadService.createLead(lead).then(() => {
                    ShiftDigitalService.updateDrLeadFormFinish(
                        quoteId,
                        this.props.vehicle,
                        this.props.vehicle.purchaseMethods.getSelectedPurchaseMethodValue()
                    );
                    this.setState({
                        showForm: false,
                        message: LocaleService.t('FORM_QUESTION.SUCCESSFULLY_SENT'),
                    });
                });
            })
            .catch(() => {
                this.setState({
                    showForm: false,
                    message: LocaleService.t('FORM_QUESTION.FAILURE'),
                });
            });
    }
    handleSDLeadEvent() {
        const { quoteId, vehicle } = this.props;
        ShiftDigitalService.updateDrLeadFormStart(quoteId, vehicle);
    }

    render() {
        const content = ContentZonesService.getContentZone('widget.vdp.used', 'appointment.background.img');

        const formBlock = this.state.showForm ? (
            <FormAskQuestion onSubmit={this.handleSubmit} handleSDLeadEvent={this.handleSDLeadEvent} />
        ) : (
            <p className="questions-successfully-sent">{this.state.message}</p>
        );

        this.style = {
            backgroundImage: content && content.getValue() !== '' ? `url(' ${content.getValue()}')` : '',
        };

        return (
            <div className="vdp-used-form" style={this.style}>
                {formBlock}
            </div>
        );
    }
}

VdpForm.propTypes = {
    vehicleId: PropTypes.number.isRequired,
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModelV25).isRequired,
    config: PropTypes.object.isRequired,
};

VdpForm.displayName = 'VdpForm';

function mapStateToProps({ quoteV25 }) {
    return {
        quoteV25,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    };
}

export { VdpForm };
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VdpForm);
